import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ko from "./locales/ko/common.json";
import en from "./locales/en/common.json";

i18n
  .use(LanguageDetector) // 브라우저 언어 자동 감지
  .use(initReactI18next)
  .init({
    resources: {
      ko: { common: ko },
      en: { common: en },
    },
    fallbackLng: "en",
    supportedLngs: ["ko", "en"],
    ns: ["common"],
    defaultNS: "common",
    interpolation: {
      escapeValue: false, // React는 XSS 안전
    },
  });

export default i18n;
